import { defineMessage } from "react-intl";

import notifyDealWarning from "./notifyDealWarning";

const dealRelinkFailedMessage = defineMessage({
  id: "deal.relink.readFailed",
  defaultMessage: "The deal couldn't be read, so it wasn't relinked",
  description:
    "Toast when relating an activity's records skipped relinking its deal because the deal couldn't be read",
});

// The relate skipped the deal because it couldn't be read; the read error is reported without a toast
const notifyDealRelinkFailed = () => notifyDealWarning(dealRelinkFailedMessage);

export default notifyDealRelinkFailed;
